<template>
  <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item>
        <el-input v-model="companyName" placeholder="请输入企业名称"></el-input>
      </el-form-item>
      <el-form-item label="经营状态" prop="operatingStatus" label-width="100px">
        <el-select v-model="operatingStatus" placeholder="经营状态" clearable style="width:130px;">
          <el-option label="营运" value="true"></el-option>
          <el-option label="停运" value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="enabled" label-width="100px">
        <el-select v-model="enabled" placeholder="请选择状态" clearable style="width:130px;">
          <el-option label="激活" value="true"></el-option>
          <el-option label="禁用" value="false"></el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.IsHide" @click="callFunc(item)">{{item.name}}</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
export default {
  name: "CompanyToolbar",
  data() {
    return {
      companyName:"", //企业名称
      operatingStatus: "true", //经营状态
      enabled: "true" //状态
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      item.companyName = this.companyName;
      item.operatingStatus = this.operatingStatus;
      item.enabled = this.enabled;
      this.$emit("callFunction", item); //将值传给父组件
    }
  }
};
</script>